import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import PaymentSection from "../components/PaymentSection";
import ScrollToTop from "react-scroll-to-top";
import NewsletterTwo from "../components/NewsletterTwo";

const PaymentPage = () => {
  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color="var(--brand-primary)" />
      <Preloader />
      <HeaderThree />
      <Breadcrumb title={"Payment"} />
      <PaymentSection />
      {/* NewsletterTwo */}
      <NewsletterTwo />
      <Footer />
    </>
  );
};

export default PaymentPage;